var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-checkbox',{attrs:{"color":"success","checked":_vm.checked},on:{"click":_vm.checkboxClicked},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }